'use strict';

const React = require('react');

const PropTypes = require('prop-types');

const {ITEM_TAG_INFO_CHAR_LIMIT} = require('../helpers/GalleryConstants');
const {GA_LINK_TARGETS} = require('../actions/galleryTrackingActions');
const styles = require('./GalleryPhotoItemTags.scss');

function onClickLink({trackLinkClick} = {}) {
    return e => {
        trackLinkClick({
            target: GA_LINK_TARGETS.TOOLTIP_LINK,
            label: e.currentTarget.href
        });
    };
}

/**
 * Returns text under char limit
 *
 * @param {string} text
 * @returns {string}
 */
function getText(text = '') {
    if (text.length < ITEM_TAG_INFO_CHAR_LIMIT) {
        return text;
    }
    return text.slice(0, ITEM_TAG_INFO_CHAR_LIMIT) + '...';
}

function GalleryPhotoItemTagInfo(props) {
    const {name, category, creator, similarItemsUrl} = props;
    const categoryCreator = category + (creator ? ` • ${creator}` : '');

    return (
        <div className={styles.itemTagInfoWrapper} onClick={e => e.stopPropagation()}>
            {/* Name */}
            <p className={styles.itemTagName} title={name}>{getText(name)}</p>

            {/* Category / Creator */}
            <p className={styles.itemTagCategoryCreator} title={categoryCreator}>
                {getText(categoryCreator)}
            </p>

            {/* View Similar Pieces > */}
            {similarItemsUrl ?
                <a className={styles.itemTagLink} href={similarItemsUrl} target='_blank' onClick={onClickLink(props)}>
                    View Similar Pieces
                </a>
            : null}
        </div>
    );
}

GalleryPhotoItemTagInfo.propTypes = {
    name: PropTypes.string,
    creator: PropTypes.string,
    category: PropTypes.string,
    similarItemsUrl: PropTypes.string,
    trackLinkClick: PropTypes.func.isRequired
};

module.exports = GalleryPhotoItemTagInfo;



// WEBPACK FOOTER //
// ./assets/js/gallery/components/GalleryPhotoItemTagInfo.jsx